export default __webpack_public_path__ + "static/media/HCHO_white.5a0b41cf.png";